import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProdutoOutput } from 'src/app/@shared/models/produto.model';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { ProdutoService } from 'src/app/services/produto/produto.service';

@Component({
  selector: 'app-modal-produtos',
  templateUrl: './modal-produtos.component.html',
  styleUrls: ['./modal-produtos.component.scss']
})

export class ModalProdutosComponent implements OnInit {
  public isLoading: boolean = false;
  public clienteInfo: any;
  public produtosInfo;
  public allSelected;

  clientes: any;
  clienteProdutos: any[];

  private onDestroy = new Subject<void>();

  produtos: ProdutoOutput[];
  public filteredProdutos: ReplaySubject<ProdutoOutput[]> = new ReplaySubject<ProdutoOutput[]>(1);
  public produtoMultiFilter: FormControl = new FormControl();

  allSelectProduct: boolean = false;
  @ViewChild("selectProduct") selectProduct: MatSelect;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
    private produtoService: ProdutoService,
    private clienteService: ClienteService,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ModalProdutosComponent>,
  ) {
    data ? this.clienteInfo = data : this.clienteInfo = null;
    data.produtos ? this.produtosInfo = data.produtos : this.produtosInfo = null;
  }

  filterForm = new FormGroup({
    produtoSelecionado: new FormControl(''),
    allProducts: new FormControl(true)
  });
  get produtoSelecionado() { return this.filterForm.get('produtoSelecionado').value; }
  get allProducts() { return this.filterForm.get('allProducts').value; }

  ngOnInit() {
    this.listarClientes();
    this.iniConfigs();
  }

  selectAll() {
    if (!this.allSelected) {
      this.allSelected = true;
    }
    else {
      this.allSelected = false;
    }
  }

  public async listarProdutos() {
    this.produtos = [];
    return this.produtoService.selecionarProdutos(this.clienteInfo.clienteId).toPromise().then((response: ProdutoOutput[]) => {
      this.produtos = response.filter(x => x.descricao != '').sort((a, b) => (a.descricao < b.descricao ? -1 : 1));
      this.filteredProdutos.next(this.produtos.slice());
      this.produtoMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.produtos, this.produtoMultiFilter, this.filteredProdutos, 'descricao');
        });
      if (!this.produtos.length) {
        this.openSnackBar('Este cliente não possui produtos cadastrados!', 'OK', 5000, 'warning-snackbar');
        this.filterForm.get('produtoSelecionado').disable();
      }
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar produtos, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  private filtroGeral(filtro: any, multifilter: any, filtered: any, field: string) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(response => response[field].toLowerCase().indexOf(search) > -1)
    );
  }

  public async listarClientes() {
    await this.clienteService.list().toPromise().then((response: any) => {
      const client = response.filter(x => x.id == this.clienteInfo?.clienteId);
      this.clientes = client[0]?.nome;
    });
  }

  buscaProdutosVinculadosCliente() {
    this.filterForm.get('produtoSelecionado').setValue(this.produtosInfo);
  }

  ngAfterViewInit() {
    if (this.produtosInfo) { this.buscaProdutosVinculadosCliente(); }
    this.esperarCarregarDados();
    this.cdr.detectChanges();
  }

  public iniConfigs() {
    if (this.produtosInfo[0] === null || !this.produtosInfo || this.produtosInfo.length === 0) {
      this.filterForm.get('allProducts').setValue(true);
    } else {
      this.filterForm.get('allProducts').setValue(false);
    }
  }

  async esperarCarregarDados() {
    await Promise.all([
      this.listarProdutos()
    ]);
    this.cdr.detectChanges();
  }

  closeProducts() {
    if (this.filterForm.get('allProducts').value === true) {
      this.dialogRef.close(null);
    } else {
      this.dialogRef.close(this.produtoSelecionado);
    }
  }

  optionClick() {
    let newStatus = true;
    this.selectProduct.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelectProduct = newStatus;
  }

  toggleAllSelectionProduct() {
    if (this.allSelectProduct) {
      this.selectProduct.options.forEach((item: MatOption) => item.select());
    } else {
      this.selectProduct.options.forEach((item: MatOption) => item.deselect());
    }
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
